/* eslint-disable @typescript-eslint/no-explicit-any */
import ProductDisplay from '../../../../components/ProductDisplayv3'

const ProductsLayout = ({
  products,
  searchTerm,
  page,
  pages,
  trackSource,
  fetchMoreData,
  onProductClick,
  category,
}: any) => {
  return (
    <ProductDisplay
      products={products}
      trackSource={trackSource}
      page={page}
      pages={pages}
      searchTerm={searchTerm}
      onProductClick={onProductClick}
      fetchMoreData={fetchMoreData}
      category={category}
    />
  )
}

export default ProductsLayout
